module.exports = "<h1 mat-dialog-title>{{content}}</h1>\r\n\r\n<crew-confirm-buttons (onOk)=\"yes()\"\r\n                      (onCancel)=\"no()\"\r\n                      [okText]=\"'Yes'\"\r\n                      [cancelText]=\"'No'\"\r\n                      [isBackToListVisible]=\"false\">\r\n</crew-confirm-buttons>"


//////////////////
// WEBPACK FOOTER
// ./client/app/shared/confirm-dialog.component.html
// module id = 1159
// module chunks = 1